import { DeliveryType } from '../types/DeliveryType';
import { links } from '../config/config';

type RedirectFn = (orderId: number) => void;

export const useDeliveryRedirects = () => {
  const map: Record<DeliveryType, RedirectFn> = {
    venipak: (orderId) => {
      window.open(links.venipak);
    },
    dpd: (orderId) => {
      window.open(links.dpd);
    },
    omniva: (orderId) => {
      window.open(links.omniva);
    },
    izipizi: (orderId) => {
      window.open(links.izipizi);
    },
    self: (orderId) => { },

    delivery: (orderId) => { },
  };

  return map;
};
